import { Box, type BoxProps, Text } from "@chakra-ui/react";
import { Trans } from "@lingui/macro";
import { TaskListItem } from "@src/components/modules/notifications/listing/components/TaskList/TaskListItem";
import type {
  TaskNotification,
  TaskNotificationScoped,
} from "@src/components/modules/notifications/listing/store";
import { Spinner } from "@src/components/ui-kit";
import classNames from "classnames";
import { observer } from "mobx-react-lite";
import type React from "react";

interface TaskListProps {
  containerClassName?: string;
  taskNotifications: TaskNotification[] | TaskNotificationScoped[];
  isLoading: boolean;
  height?: BoxProps["height"];
}

const TaskList: React.VFC<TaskListProps> = ({
  containerClassName,
  taskNotifications,
  isLoading,
  height,
}) => {
  return (
    <Box
      className={classNames(
        "border-2 border-gray-300 rounded-md",
        containerClassName,
      )}
      overflowY="scroll"
      h={height ? height : "60.5rem"}
      bg="#f4f6f8"
    >
      {isLoading && (
        <Box py="3">
          <Spinner size="sm" />
        </Box>
      )}
      {!isLoading &&
        taskNotifications.map((item, index) => (
          <TaskListItem
            key={item.task.id}
            task={item.task}
            borderBottomWidth={
              index === taskNotifications.length - 1 ? 0 : "1px"
            }
            notifications={item.notifications}
          />
        ))}
      {!isLoading && !taskNotifications.length && (
        <Text align="center" p="8">
          <Trans>You don't have any notifications</Trans>
        </Text>
      )}
    </Box>
  );
};

export default observer(TaskList);
